<template>
    <div class="apprentice-simple-card">
        <div class="description">
            {{ $t('user_account.import.choose_an_excel_list_below_to_upload') }}
            <b-alert
                v-if="lasConnectionIn"
                variant="danger"
                show
                ><br /><br />{{
                    $t(
                        'user_account.import.please_note_this_school_has_a_las_connection_you_can_still_use_this_tool_to_quickly_see_which_users_you_still_need_to_add_manually_based_on_email_address',
                    )
                }}</b-alert
            >
        </div>
        <b-alert
            v-if="hasError"
            show
            variant="danger">
            {{ $t('user_account.import.first_you_must_upload_an_excel_list') }}
        </b-alert>
        <b-form-group
            class="group-input-file"
            :label="$t('user_account.import.excel_list')"
            label-for="grouppair-excel-input">
            <b-form-file
                class="apprentice-file-upload grouppair-excel-upload"
                id="grouppair-excel-input"
                v-model="file"
                accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                :placeholder="$t('user_account.upload_excel_list')">
            </b-form-file>
        </b-form-group>
        <br />
        <b-button
            class="btn-save btn-save-excel-input-accounts"
            variant="primary"
            @click="save()">
            {{ $t('user_account.upload') }}
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'design-2021-accounts-import-upload-component',
    props: ['lasConnectionIn'],
    data() {
        return {
            file: null,
            hasError: false,
        };
    },
    methods: {
        save() {
            this.hasError = false;
            if (this.file === null || this.file === '') {
                this.hasError = true;
                return;
            }

            const formData = new FormData();
            formData.append('file', this.file);
            this.alert.saving();

            const headers = { 'Content-type': 'multipart/form-data' };

            axios
                .post(this.routes.schoolAccountImport(), formData, { headers: headers })
                .then((response) => {
                    window.location.href = this.routes.schoolAccountImportSettings(response.data.id);
                })
                .catch(function (error) {
                    this.alert.ajaxError(error);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.description {
    color: $text-muted-color;
    font-weight: $font-weight-medium;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}
</style>
